module.exports = __webpack_public_path__ + "static/media/orangeroom.879ad824.png";